import { Component } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { MemoryModalComponent } from '../memory-modal/memory-modal.component';
import MainScene from '../Scenes/MainScene';
import BaseLevelScene from '../Scenes/BaseLevelScene';
import { GlobalService } from '../services/global.service';

@Component({
  selector: 'app-memory-viewer',
  templateUrl: './memory-viewer.component.html',
  styleUrls: ['./memory-viewer.component.scss'],
})
export class MemoryViewerComponent {
  private static modal: HTMLIonModalElement;
  private static modalCtrl: ModalController;

  constructor(private modalCtrl: ModalController) {
    MemoryViewerComponent.modalCtrl = this.modalCtrl;
  }

  public static openModal(memoryName: string, scene?: MainScene | BaseLevelScene, displayProfileButton=true) {
    console.log(`MemoryViewer memoryName: ${memoryName}`);
    MemoryViewerComponent.modalCtrl
      .create({
        component: MemoryModalComponent,
        componentProps: {
          scene: scene,
          memoryName: memoryName,
          displayProfileButton,
        },
        // cssClass: cssClass
      })
      .then((modal) => {
        MemoryViewerComponent.modal = modal;
        MemoryViewerComponent.modal.present();
        GlobalService.incrementModalCount();
        MemoryViewerComponent.modal.onDidDismiss().then(() => {
          GlobalService.decrementModalCount();
        });
      });
  }
}
